var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M12.625 4.3L9.249 7a2 2 0 0 1-2.498 0L3.375 4.3A1 1 0 0 1 3 3.52V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v.52a1 1 0 0 1-.375.78zM6.75 9a2 2 0 0 1 2.498 0l3.376 2.7a1 1 0 0 1 .375.78V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.52a1 1 0 0 1 .375-.78L6.751 9zM2.5 15h11a.5.5 0 1 1 0 1h-11a.5.5 0 1 1 0-1zm0-15h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1 0-1z" })
  );
});